angular.module('bizmetryApp').controller('ResourceExplorerDialogController', function (
    $scope, $mdDialog, $q, ResourceService, ProfileService, profile, resourceTypeId
) {
    var vm = this, requestSequence = 0, profileSequence = 0, disposed = false;
    // Opened from the main menu there is no caller profile: the first loaded profile is selected.
    vm.profiles = profile ? [profile] : [];
    vm.types = [];
    vm.environments = (profile && profile.environments) || [];
    vm.filters = { profileId: profile ? profile.id : '', resourceType: resourceTypeId === 'ALL' ? '' : (resourceTypeId || ''), environmentId: '', search: '' };
    vm.page = 0; vm.size = 25; vm.total = 0; vm.pages = 0;
    vm.sortBy = 'resourceName'; vm.direction = 'ASC';
    vm.sortOptions = [{key: 'resourceName', label: 'Resource name'}, {key: 'createdTs', label: 'Resource created at'}];
    vm.rows = []; vm.columns = []; vm.loading = false; vm.loadingFilters = false;
    vm.jsonViewer = { open: false };
    vm.highlightTerm = '';
    var applied = angular.copy(vm.filters);
    function clearRows() { vm.rows = []; vm.columns = []; vm.total = 0; vm.pages = 0; }
    function message(error, fallback) {
        return error.status === 403 ? 'You do not have permission to explore imported datasource records.' :
            ((error.data && error.data.message) || fallback);
    }
    function load() {
        if (disposed || !applied.profileId) return;
        var sequence = ++requestSequence;
        vm.loading = true; vm.error = ''; vm.jsonViewer.open = false; clearRows();
        return ResourceService.exploreResources(applied.profileId, {
            resourceType: applied.resourceType, environmentId: applied.environmentId,
            search: applied.search, page: vm.page, size: vm.size, sortBy: vm.sortBy, direction: vm.direction
        }).then(function (res) {
            if (disposed || sequence !== requestSequence) return;
            var data = res.data || {};
            vm.rows = data.rows || []; vm.columns = data.columns || [];
            vm.highlightTerm = applied.search; // the term that produced these rows, not the one being typed
            vm.sortOptions = vm.columns.filter(function (column) { return column.key !== 'source.is_enabled'; });
            var descriptions = vm.columns.filter(function (column) { return column.role === 'RD'; });
            vm.rows.forEach(function (row) {
                if (row.resourceDescription) return;
                var description = descriptions.find(function (column) { return row[column.key] != null; });
                if (description) row.resourceDescription = vm.cell(row[description.key]);
            });
            vm.columns = [
                {key: 'enabled', label: 'Enabled', checkbox: true},
                {key: 'resourceName', label: 'Resource', identity: true},
                {key: 'environment', label: 'Environment'},
                {key: 'resourceType', label: 'Resource type'},
                {key: 'createdTs', label: 'Created', format: 'timestamp'},
                {key: 'updatedTs', label: 'Updated', format: 'timestamp'}
            ].concat(vm.columns.filter(function (column) {
                return ['PK', 'RN', 'RD'].indexOf(column.role) === -1 &&
                    ['enabled', 'environment', 'resourceType', 'resourceName', 'resourceDescription', 'resourceId', 'createdTs', 'updatedTs', 'source.is_enabled'].indexOf(column.key) === -1;
            }));
            ['resourceName', 'createdTs', 'updatedTs'].forEach(function (key, index) {
                if (!vm.sortOptions.some(function (column) { return column.key === key; }))
                    vm.sortOptions.push({key: key, label: ['Resource name', 'Resource created at', 'Resource updated at'][index]});
            });
            vm.total = data.totalElements || 0; vm.pages = data.totalPages || 0;
            vm.page = data.page || 0;
        }).catch(function (error) {
            if (!disposed && sequence === requestSequence) vm.error = message(error, 'Could not load resources. Please retry.');
        }).finally(function () { if (!disposed && sequence === requestSequence) vm.loading = false; });
    }
    vm.search = function () {
        if (disposed || vm.loadingFilters || !vm.selectedProfile || vm.selectedProfile.id !== vm.filters.profileId) return;
        applied = angular.copy(vm.filters);
        applied.search = (applied.search || '').trim();
        vm.page = 0;
        return load();
    };
    vm.goToPage = function (page) {
        if (vm.loading || page < 0 || page >= vm.pages) return;
        vm.page = page; return load();
    };
    vm.changePageSize = function () { vm.page = 0; return load(); };
    vm.changeSort = function () { vm.page = 0; return load(); };
    vm.sort = function (column) {
        vm.direction = vm.sortBy === column.key && vm.direction === 'ASC' ? 'DESC' : 'ASC';
        vm.sortBy = column.key; vm.page = 0; return load();
    };
    vm.criteriaChanged = function () {
        ++requestSequence; vm.loading = false; vm.error = ''; clearRows(); vm.page = 0;
        return vm.search();
    };
    vm.changeProfile = function () {
        ++requestSequence; vm.loading = false; vm.error = ''; clearRows(); vm.page = 0;
        vm.filters.resourceType = ''; vm.filters.environmentId = '';
        vm.types = []; vm.environments = []; vm.loadingFilters = true;
        vm.filterError = '';
        var sequence = ++profileSequence, id = vm.filters.profileId;
        return $q.all([ResourceService.getResourceTypesByProfile(id), ProfileService.getProfileById(id)])
            .then(function (responses) {
                if (disposed || sequence !== profileSequence) return;
                vm.types = (responses[0].data || {}).resource_types || [];
                vm.environments = (responses[1].data || {}).environments || [];
            }).catch(function (error) {
                if (!disposed && sequence === profileSequence) vm.filterError = message(error, 'Could not load profile filters. Select the profile again to retry.');
            }).finally(function () { if (!disposed && sequence === profileSequence) { vm.loadingFilters = false; if (!vm.filterError) vm.search(); } });
    };
    // Fetch every API page; selecting a profile never depends on typing a search.
    vm.profileSelectionId = profile ? profile.id : null;
    vm.loadProfiles = function () {
        vm.loadingProfiles = true; vm.profileError = '';
        var choices = new Map(profile ? [[profile.id, profile]] : []);
        function page(number) {
            return ProfileService.getAllProfiles({ page: number, size: 100, sortCriteria: 'profileName', sortDirection: 'ASC' })
                .then(function (res) {
                    if (disposed) return;
                    var data = res.data || {};
                    (data.profiles || []).forEach(function (item) { choices.set(item.id, item); });
                    var count = (data.paging || {}).pageCount || 1;
                    if (number + 1 < count) return page(number + 1);
                    vm.profiles = Array.from(choices.values()).sort(function (a, b) {
                        return (a.profileName || '').localeCompare(b.profileName || '');
                    });
                    if (!vm.selectedProfile && vm.profiles.length) {
                        vm.profileSelectionId = vm.profiles[0].id;
                        return vm.selectProfile(vm.profiles[0]);
                    }
                });
        }
        return page(0).catch(function () {
            if (!disposed) vm.profileError = 'Could not load all profiles. Please retry.';
        }).finally(function () { if (!disposed) vm.loadingProfiles = false; });
    };
    vm.selectProfileId = function () {
        return vm.selectProfile(vm.profiles.find(function (item) { return item.id === vm.profileSelectionId; }));
    };
    vm.selectedProfile = profile;
    vm.selectProfile = function (selected) {
        vm.selectedProfile = selected;
        if (!selected || selected.id === vm.filters.profileId) return;
        vm.filters.profileId = selected.id; return vm.changeProfile();
    };
    vm.cell = function (value) {
        if (value === null || value === undefined) return 'NULL';
        return typeof value === 'object' ? JSON.stringify(value) : String(value);
    };
    vm.isJson = function (value) {
        if (value === null || value === undefined) return false;
        if (typeof value === 'object') return true;
        if (typeof value !== 'string') return false;
        try { var parsed = JSON.parse(value); return parsed !== null && typeof parsed === 'object'; }
        catch (error) { return false; }
    };
    vm.inspect = function (column, row) {
        if (!vm.isJson(row[column.key])) return;
        vm.jsonViewer = { open: true, title: row.resourceName + ' · ' + row.environment + ' · ' + column.label,
            json: row[column.key], query: applied.search };
    };
    // md-select opens its panel over the select, covering it; place it right below instead
    // (same approach as the Metrics Explorer). Above only when it doesn't fit below.
    var dropdownTrigger = null, panelObserver = null;
    vm.rememberDropdownTrigger = function (event) { dropdownTrigger = event.currentTarget; };
    function placeBelowTrigger(panel) {
        if (!dropdownTrigger || !document.body.contains(dropdownTrigger)) return;
        var rect = dropdownTrigger.getBoundingClientRect(), height = panel.offsetHeight;
        var top = rect.bottom + 4;
        if (top + height > window.innerHeight - 8) {
            top = rect.top - height - 4 >= 8 ? rect.top - height - 4 : Math.max(8, window.innerHeight - height - 8);
        }
        var left = Math.min(rect.left, window.innerWidth - panel.offsetWidth - 8);
        panel.style.transform = 'none';
        panel.style.top = top + 'px';
        panel.style.left = Math.max(8, left) + 'px';
        panel.style.minWidth = rect.width + 'px';
    }
    if (typeof MutationObserver !== 'undefined') {
        panelObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
                    if (node.nodeType !== 1 || !node.classList.contains('re-dropdown-panel')) return;
                    // Wait for md-select to apply its own position, then override it once.
                    var settled = false;
                    var settle = function () { if (settled) return; settled = true; styleObserver.disconnect(); placeBelowTrigger(node); };
                    var styleObserver = new MutationObserver(settle);
                    styleObserver.observe(node, { attributes: true, attributeFilter: ['style'] });
                    setTimeout(settle, 100);
                });
            });
        });
        panelObserver.observe(document.body, { childList: true });
    }
    function onKeydown(event) {
        if (event.key === 'Escape' && vm.jsonViewer.open) {
            event.stopPropagation();
            $scope.$apply(function () { vm.jsonViewer.open = false; });
        }
    }
    document.addEventListener('keydown', onKeydown, true);
    vm.close = function () { $mdDialog.hide(); };
    $scope.$on('$destroy', function () { disposed = true; ++requestSequence; ++profileSequence; document.removeEventListener('keydown', onKeydown, true); if (panelObserver) panelObserver.disconnect(); });
    if (profile) ResourceService.getResourceTypesByProfile(profile.id).then(function (res) {
        if (!disposed && profileSequence === 0) vm.types = (res.data || {}).resource_types || [];
    }).catch(function () { if (!disposed && profileSequence === 0) vm.filterError = 'Could not load resource types. Re-select the profile to retry.'; });
    vm.loadProfiles();
    vm.search();
});
